import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAccommodationContact($companyId: ID!, $id: ID!) {
    deleteAccommodationContact(companyId: $companyId, id: $id) {
      accommodationContact {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
